export enum ControlPanelInputVoltage {
  Vac208Y120 = 'Vac208Y120',
  Vac400Y230 = 'Vac400Y230',
}
